import { axiosInterceptor } from "../AxiosInterceptor";

export default class ExpenditureListRepository {
  static async expenditureList(queryString = "") {
    let result = {
      status: false,
      data: null,
    };
    try {
      const response = await axiosInterceptor.get(
        "/finance/payments/expenditure/?" + queryString
      );
      if (response.status === 200) {
        result = { ...result, status: true, data: response.data.data };
      }
    } catch (e) {
      result = { ...result, nonFieldErrors: "Ma'lumot olib bo'lmadi" };
    }
    return result;
  }
}
